import { z } from 'zod';

import type {
  GetHoldingUnitBusinessActivityRequest,
  GetHoldingUnitBusinessActivityResponse,
  HoldingUnitBusinessActivityChange,
  HoldingUnitBusinessActivityEntry,
  HoldingUnitBusinessActivityReference,
  HoldingUnitBusinessActivityWeight,
} from './holding-unit-business-activity.dto.js';
import { holdingUnitBusinessActivityKindValues } from './holding-unit-business-activity.dto.js';

export const HoldingUnitBusinessActivityKindSchema = z.enum(holdingUnitBusinessActivityKindValues);

export const HoldingUnitBusinessActivityWeightSchema: z.ZodType<HoldingUnitBusinessActivityWeight> =
  z
    .object({
      beforeNetLb: z.number().nonnegative().optional(),
      addedNetLb: z.number().nonnegative().optional(),
      afterNetLb: z.number().nonnegative().optional(),
      grossLb: z.number().nonnegative().nullable().optional(),
      tareLb: z.number().nonnegative().nullable().optional(),
      deltaNetLb: z.number().optional(),
    })
    .strict();

export const HoldingUnitBusinessActivityChangeSchema: z.ZodType<HoldingUnitBusinessActivityChange> =
  z
    .object({
      label: z.string().trim().min(1),
      fromDisplay: z.string().trim().min(1).nullable(),
      toDisplay: z.string().trim().min(1).nullable(),
      note: z.string().trim().min(1).nullable(),
    })
    .strict();

export const HoldingUnitBusinessActivityReferenceSchema: z.ZodType<HoldingUnitBusinessActivityReference> =
  z
    .object({
      label: z.string().trim().min(1),
      value: z.string().trim().min(1),
    })
    .strict();

export const HoldingUnitBusinessActivityEntrySchema: z.ZodType<HoldingUnitBusinessActivityEntry> = z
  .object({
    kind: HoldingUnitBusinessActivityKindSchema,
    occurredAt: z.iso.datetime(),
    actorLabel: z.string().trim().min(1),
    title: z.string().trim().min(1),
    summary: z.string().trim().min(1).nullable(),
    reason: z.string().trim().min(1).max(500).nullable(),
    weight: HoldingUnitBusinessActivityWeightSchema.nullable(),
    changes: z.array(HoldingUnitBusinessActivityChangeSchema),
    references: z.array(HoldingUnitBusinessActivityReferenceSchema),
  })
  .strict();

export const GetHoldingUnitBusinessActivityRequestSchema: z.ZodType<GetHoldingUnitBusinessActivityRequest> =
  z
    .object({
      companyId: z.uuid(),
      unitId: z.uuid(),
    })
    .strict();

export const GetHoldingUnitBusinessActivityResponseSchema: z.ZodType<GetHoldingUnitBusinessActivityResponse> =
  z
    .object({
      items: z.array(HoldingUnitBusinessActivityEntrySchema),
    })
    .strict();
